import { useMutation, useQuery } from "@tanstack/react-query";
import { NOTIFICATIONS } from "./types";
import { getNotifications, postMarkAllRead, postMarkRead } from "./requests";
import { INotification } from "~/types/notifications";
import { ISidebarCount } from "../sidebarCounts/types";

export const useGetNotifications = () =>
  useQuery<INotification[]>(NOTIFICATIONS, () => getNotifications(), {
    staleTime: 60 * 1000, // 1 min — show cached notifications instantly on revisit
  });

export const useMarkAllNotificationsRead = () => useMutation(postMarkAllRead);

export const useMarkNotificationRead = () => useMutation(postMarkRead);

export const useGetUnreadNotifications = () =>
  useQuery<INotification[], Error, ISidebarCount>(
    NOTIFICATIONS,
    () => getNotifications(),
    {
      staleTime: 60 * 1000,
      select: (notifications) => ({
        count: notifications.filter(
          (notification) => !notification.is_read
        ).length,
      }),
    }
  );
